<template>
<el-menu
  :default-active="currentPath"
router
  mode="horizontal"
  background-color="#4cb050"
  text-color="#fff"
  active-text-color="#ffd04b"

  >
  <el-menu-item index="/#/" style="max-width:80px">首页</el-menu-item>
  <el-submenu  index="2" style="width: 100px;">
    <template slot="title">新闻中心</template>
    <el-menu-item index="/news" >新闻动态</el-menu-item>
    <el-menu-item index="/localNews">地方要闻</el-menu-item>
  </el-submenu>
  <el-submenu index="3" style="width: 100px;">
    <template slot="title">交易项目</template>
    <el-menu-item index="/transferList" >转让项目</el-menu-item>
    <el-menu-item index="/demandList" >需求项目</el-menu-item>
    <el-menu-item index="/procureList" >采购项目</el-menu-item>
    <el-menu-item index="/doneDealList" >成交公告</el-menu-item>
    <el-menu-item index="/verifyList" >鉴证公示</el-menu-item>
  </el-submenu>

  
  <el-menu-item v-if="unitCode=='411500000000'" index="/stateOwnedList" style="width: 100px;">国有资产</el-menu-item>

  <el-menu-item index="/productList" style="width: 120px;">农产品交易</el-menu-item>


  <el-submenu index="4" style="width: 110px;">
    <template slot="title">通知公告</template>
    <el-menu-item index="notice">通知公告</el-menu-item>
    <el-menu-item index="dealNotice">处置公告</el-menu-item>
  </el-submenu>
  <!-- <span style="width:auto;height:60px;line-height:60px;float:left" @click="jumpBidding()">
   <el-menu-item  index="/enrollProjectAlready" disabled style="width: 120px;color:white;line-height:60px;">电子竞价</el-menu-item>
   </span> -->

   <el-submenu index="5" style="width: 110px;">
     <template slot="title">电子竞价</template>
     <el-menu-item index="/showBiddingList">观摩竞价</el-menu-item>
     <el-menu-item index="/enrollProjectAlready">参与竞价</el-menu-item>
   </el-submenu>

   <el-menu-item  index="/bigScreen" style="width: 120px;" >交易大数据</el-menu-item>

  <el-submenu index="6" style="width: 110px;">
    <template slot="title">交易指南</template>
   <el-menu-item index="/tradeRule">交易规则</el-menu-item>
    <el-menu-item index="/tradeProcess">交易流程</el-menu-item>

  </el-submenu>

  <el-menu-item index="/fileDownloadList" style="width: 110px;">资料下载</el-menu-item>

   <el-menu-item   index="/contactUs" style="width:110px;">联系我们</el-menu-item>
<!--    <el-menu-item index="/messageSearch" style="width: 110px;">互动交流</el-menu-item> -->




</el-menu>

</template>

<script>
export default {
  props: ['isCollapse'],
  data () {
    return {
      currentPath: location.pathname,
      unitCode:localStorage.getItem("unitCode")
    }
  },
  methods:{
    jumpBidding(){
    this.$router.push("/");
      const { href } = this.$router.resolve({
        path: "/enrollProjectAlready",
        query: {},
        });
      window.open(href, '_blank');
    }
  }
}
</script>

<style lang="css" >
  @import url("../../assets/css/index.css");
  @import url("../../assets/css/base.css");
  @import url("../../assets/css/main.css");
  @import url("../../assets/css/news.css");
  .el-menu-item.is-disabled {
      opacity: 1!important;
      cursor: pointer!important;
      background: 0 0!important;
  }
  .el-menu {
    border: none;
  }
  .menu-nav:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .el-menu-item{
    width: 120px!important;
    text-align: center;
    line-height: 60px;
    height: 60px;
    font-size: 16px!important;
  }
  .el-submenu{
      font-size: 16px!important;
  }
  .el-submenu__title{
     font-size: 16px!important;
  }

.el-menu-item.is-active {
      background-color: #0594c9 !important;
      color: #fff;
      border-bottom:none !important;
     /* span {
        color: #fff !important;
      } */
    }
.el-menu-item-group .el-menu-item.demo:hover{
    background: #0594c9 !important;
    color: #fff !important;
    }


  .el-menu--collapse .el-menu .el-submenu, .el-menu--popup{
    width: 120px!important;
  }

  .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
  	display: none;

  }

  .el-submenu>.el-submenu__title .el-submenu__icon-arrow{
  	display: none;

  }

  .el-menu--collapse .el-menu .el-submenu, .el-menu--popup{
    min-width: 120px!important;
  }



</style>
